import {
  Alert,
  AppHeader,
  AppHeaderBackButton,
  Box,
  Button,
  ButtonGroup,
  Container,
  Paper,
  Stack,
  Typography,
} from '@ace-clublabs/shared-component-library';
import { useLayoutEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Pages } from '../utils/constants';
import { setGlobalState, useGlobalState } from '../state/state';
import { MembershipProductType } from '@ace-clublabs/common-membership-api-types';
import { ClubCode, MSSProductStatus } from '@lib/types';
import { getTermPeriodText } from '../utils/ruleHelper';
import { stringHelper } from '../utils/stringHelper';
import { UtagHelper, UtagType } from '../utils/UtagHelper';

export const AddRVMotorcycle: React.FC = () => {
  const history = useHistory();
  const [formData] = useGlobalState('formData');
  const [memberDetails] = useGlobalState('memberDetails');
  const [isMobileApp] = useGlobalState('isMobileApp');
  const [tags] = useGlobalState('tags');
  const { clubCode } = memberDetails;
  const [prospectiveCosts] = useGlobalState('prospectiveCosts');
  const [isTagging, setTagging] = useState(true);

  const inRenewal = memberDetails.inRenewal;
  const isRVRemoved = formData?.products?.some(
    (product) => product.type === MembershipProductType.RV && product.status === MSSProductStatus.REMOVED
  );

  const benefitLevel = formData?.requestedMembershipLevel;
  // @ts-ignore
  const rvCost: number = prospectiveCosts[benefitLevel?.toLowerCase()]?.products?.RV;

  const addRVMotorcycle = () =>
    setGlobalState('formData', {
      ...formData,
      products: [
        {
          type: MembershipProductType.RV,
          status: isRVRemoved ? MSSProductStatus.EXISTING : MSSProductStatus.ADDED,
        },
      ],
    });

  useLayoutEffect(() => {
    UtagHelper.sendTag(UtagType.view, tags, 'add rv');
    setTagging(false);
  }, []);

  if (isTagging) {
    return <></>;
  }

  return (
    <Container maxWidth="sm">
      <Box>
        <AppHeader backButton={!isMobileApp && <AppHeaderBackButton />} />
        <Stack>
          <Stack alignItems="flex-start" sx={{ marginBottom: '1rem' }}>
            <Typography variant="h5" className="add-rv-title" sx={{ fontWeight: 500, lineHeight: '2rem' }}>
              Add RV/motorcycle roadside
            </Typography>
            <Stack direction="row" alignItems="baseline" sx={{ height: '2rem' }} className="add-rv-cost">
              <Typography variant="h5">{stringHelper.formatMoney(rvCost?.toString())}</Typography>
              <Typography variant="b3Regular">
                {' '}
                /{getTermPeriodText(inRenewal!, formData?.requestedBillPlan!)}
              </Typography>
            </Stack>
          </Stack>
          <Box className="add-rv-benefit-container">
            <Paper sx={{ backgroundColor: '#F7F8FA', padding: '1rem' }}>
              <Typography variant="b1Medium" sx={{ marginBottom: '0.5rem' }}>
                Benefits
              </Typography>
              <Typography variant="b1Regular" sx={{ marginLeft: '0.5rem' }}>
                <li>Get 4 more calls for RV/motorcycle towing, extrication and winching, and RV tire changes</li>
                <li>Up to $500 per service call</li>
                <li>Up to $1,000 per household per membership year </li>
              </Typography>
              <Typography variant="b1Regular" sx={{ paddingTop: '1rem' }}>
                Members are responsible for all other expenses over the maximum benefit amounts.
              </Typography>
            </Paper>
          </Box>

          <Alert severity="warning" icon={false} displayCloseButton={false} sx={{ marginTop: '1rem' }}>
            <Typography variant="b1Regular" className="effective-day-alert">
              Changes <strong>will be effective 7 days</strong> after full payment is received.
            </Typography>
          </Alert>
          <ButtonGroup sx={{ marginTop: '1.5rem' }}>
            <Button
              label="Add RV/motorcycle roadside"
              className="add-rv-button"
              onClick={() => {
                addRVMotorcycle();
                history.push({
                  pathname: Pages.ManageMembershipPage,
                  search: UtagHelper.getIntcmpQueryParam(Pages.AddRVMotorcycle, 'addrvmotorcycleroadside'),
                });
              }}
            />
            <Button
              variant="outlined"
              label="Cancel"
              className="cancel-button"
              onClick={() => history.push(Pages.ManageMembershipPage)}
            />
          </ButtonGroup>
          {(clubCode === ClubCode.EC || clubCode === ClubCode.ACMO) && (
            <Stack sx={{ marginTop: '1rem', marginBottom: '1.375rem' }} gap="1rem" className="RV-motorcycle-disclaimer">
              <Typography variant="b3Regular" sx={{ color: '#404040' }}>
                Motorcycles that are licensed for highway use and are not altered, constructed, or customized in such a
                way to cause damage or create a hazard when being serviced are eligible for service under RV and
                motorcycle towing and RV tire change service. Certain limitations on motorcycle towing apply.
              </Typography>
              <Typography variant="b3Regular" sx={{ color: '#404040' }}>
                Boat trailers, personal watercraft trailers and ATV trailers must be either empty or transporting
                recreational vehicles or equipment. Utility trailers must be carrying recreational equipment (for
                non-commercial use). Commercial trailers are excluded. Service does not include transportation of
                horses. Please see the Member Guide for details.
              </Typography>
              <Typography variant="b3Regular" sx={{ color: '#404040' }}>
                Members who have Optional RV and Motorcycle Roadside Assistance are entitled to an additional four (4)
                Roadside Assistance calls or reimbursements for RV or motorcycle towing or RV tire change service per
                household per membership year.
              </Typography>
            </Stack>
          )}
        </Stack>
      </Box>
    </Container>
  );
};
